import React, { useContext, useState } from "react";
import { Dialog, Table } from "../../../../../layout";
import TableProdWidget from "../../../../Sales/POS/QuoteSale/ViewQuote/TableProdWidget";
import { PrintDiv, useFormatPrice } from "../../../../../hooks/Method";
import ViewProd from "../../../../Catalog/Product/ViewProduct/ViewProd";
import { Button } from "../../../../../controls";
import { LocalPrintshopRounded } from "@mui/icons-material";
import ProductStatus from "./ProductStatus";
import PrintReceipt from "../../../../Sales/SaleReturn/PrintReceipt/PrintReceipt";
import { AppContext } from "App";

const ReturnProducts = ({ value }) => {
  const { access } = useContext(AppContext);

  const formatPrice = useFormatPrice();
  const [showDetails, setShowDetails] = useState(false);
  const [viewProdId, setViewProdId] = useState();

  const handleView = (val) => {
    setShowDetails(!showDetails);
    setViewProdId(val.prodId);
  };

  const handlePrint = () => {
    setTimeout(() => {
      PrintDiv("printReturnReceipt");
    }, 500);
  };

  const HeaderComp = () =>
    access?.salesHistory?.printReceipt && (
      <Button
        onClick={handlePrint}
        variant="text"
        startIcon={<LocalPrintshopRounded />}
      >
        Print Receipt
      </Button>
    );

  return (
    <>
      {value && value.returnItems && (
        <>
          <div className="d-none" id="printReturnReceipt">
            {value && value.id && <PrintReceipt data={value} />}
          </div>

          <div>
            <Table
              ActionComp={() => <></>}
              HeaderComp={() => <HeaderComp />}
              showHeader={false}
              tblHead={[
                { id: "status", label: "Status/Reason" },
                { id: "product", label: "Product" },
                { id: "returnQty", label: "Return Qty" },
                { id: "returnAmt", label: "Total Price" },
              ]}
              tblData={value.returnItems.map((item) => {
                return {
                  ...item,
                  status: <ProductStatus value={item} />,
                  searchTerm: item.prod
                    ? `${item.prod.name} ${item.prod.skuCode}`
                    : "",
                  product: (
                    <TableProdWidget
                      {...{
                        handleView,
                        item,
                        discount: item.discAdj
                          ? `Disc. Adjustment: (-) ${formatPrice(item.discAdj)}`
                          : "",
                      }}
                    />
                  ),
                  returnAmt: <span>{formatPrice(item.returnAmt)}</span>,
                };
              })}
            />
          </div>
        </>
      )}
      {/* View Product */}
      {showDetails && (
        <Dialog show={showDetails} onClose={false} maxWidth="lg">
          <ViewProd {...{ setShowForm: setShowDetails, id: viewProdId }} />
        </Dialog>
      )}
    </>
  );
};

export default ReturnProducts;
